<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
        <path
            d="M7.21771 21.5292C6.43049 22.3175 5.08325 21.76 5.08325 20.6459V15.6456H10.0883C11.2017 15.6456 11.7595 16.9914 10.9726 17.7791L9.41794 19.3352C10.6898 20.6357 12.4309 21.3707 14.2499 21.3748C17.1597 21.3705 19.7517 19.5348 20.7216 16.7914H20.7422C20.8735 16.4186 20.9727 16.0353 21.039 15.6456H23.3444C22.767 20.2288 18.8694 23.6663 14.2499 23.6665H14.2385C11.8079 23.6737 9.47542 22.7082 7.76106 20.9852L7.21771 21.5292ZM7.45971 13.3539H5.15429C5.73151 8.77244 9.62648 5.33556 14.2442 5.33305H14.2499C16.681 5.32528 19.014 6.29083 20.7285 8.01435L21.2838 7.4604C22.0717 6.67448 23.4166 7.23254 23.4166 8.3454V13.3539H18.4148C17.301 13.3539 16.7434 12.0071 17.5312 11.2198L19.0876 9.66435C17.8145 8.36228 16.071 7.62722 14.2499 7.62477C11.3401 7.62906 8.74818 9.46473 7.77825 12.2081H7.75763C7.62535 12.5806 7.5249 12.964 7.45971 13.3539Z"
            fill="#3E8DFF" />
    </svg>
</template>

<script>
export default {
    name: 'RefreshIconPrimary'
}
</script>